import { queryOptions, useMutation, useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'

import { ApiGateway } from '@/modules/api/api.gateway'

import { EmailsToSendRepository } from '../../core/emails-to-send.repository'
import { CreateCustomEmailToSendBody } from '../../core/emails-to-send.schema'
import { EmailsToSendService } from '../../core/emails-to-send.service'

const apiGateway = new ApiGateway()
const emailToSendRepository = new EmailsToSendRepository(apiGateway)
const emailToSendService = new EmailsToSendService(emailToSendRepository)

const emailsToSendQuery = (id?: string) =>
  queryOptions({
    enabled: !!id,
    queryFn: () => (id ? emailToSendService.get(id) : Promise.reject('No email template ID provided')),
    queryKey: ['emailsToSendQuery', id],
  })

export const useEmailsToSend = (id?: string) => useQuery(emailsToSendQuery(id))

export function useCreateEmailsToSendCustom() {
  return useMutation({
    mutationFn: (body: CreateCustomEmailToSendBody) => emailToSendService.createCustom(body),
    onMutate: () => {
      toast.loading('Creating email...', {
        id: 'create-email',
      })
    },
    onError: () => {
      toast.dismiss('create-email')
    },
    onSuccess: () => {
      toast.success('Email created successfully.', {
        id: 'create-email',
      })
    },
  })
}
